import { inject, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { LogLevel } from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { NotifyUserSignalrPayload } from '../models/signalr_payloads';
import { environment } from 'src/environments/environment';
import { SsoService } from '@devinforius/i-sso';
@Injectable({
  providedIn: 'root',
})
export class SignalrService {
  private readonly ssoService = inject(SsoService)
  private hubConnection: signalR.HubConnection;

  private notifyUserSignalrSource = new Subject();
  notifyUser = this.notifyUserSignalrSource.asObservable();

  public register = () => {
    // Implement IRetryPolicy interface to continuously reconnect
    class FiveSecondsReconnectPolicy implements signalR.IRetryPolicy {
      nextRetryDelayInMilliseconds(retryContext: signalR.RetryContext): number {
        // retry after 2 seconds else 5 seconds
        return retryContext.elapsedMilliseconds < 2000 ? 2000 : 5000;
      }
    }

    const config = environment;
    const iCourrierBase = environment.production ? '/iCourriers' : '/iCourriers2nd';
    const signalRURL = '/SignalR/NotificationsHub';
    const signalrHubUrl = config.apiGatewayBaseUrl + iCourrierBase + signalRURL;

    const reconnectPolicy = new FiveSecondsReconnectPolicy();
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(signalrHubUrl, { accessTokenFactory: () => this.ssoService.accessToken() })
      .configureLogging(LogLevel.Information) // TODO: disable logs in production mode
      .withAutomaticReconnect(reconnectPolicy) // continuously reconnect every 5 seconds
      .build();

    this.InitHubEvents();
  };

  public startConnection = (succesCallback, errorCallback) => {
    this.hubConnection
      .start()
      .then(() => {
        if (succesCallback) {
          succesCallback();
        }
      })
      .catch(() => {
        if (errorCallback) {
          console.error('SignalR connection error');
          errorCallback();
        }
      });
  };

  private InitHubEvents() {
    this.hubConnection.onreconnected(() => {
      console.info('reconnected');
    });
    this.hubConnection.onclose(() => {
      console.info('SignalR connection closed');
    });

    this.hubConnection.on('notifyUser', (payload: NotifyUserSignalrPayload) => {
      this.notifyUserSignalrSource.next(payload);
    });
  }

  public sendMessageToMe(message: string) {
    this.hubConnection.send('sendMessageToMe', message);
  }

  public stop() {
    this.hubConnection.stop();
  }
}
